import React from 'react';

function MessageUser({children, clickModify,isNotModify}) {
    return (
      <div className="flex flex-col items-end justify-end mb-4">
        <div className="bg-[#667085] text-white rounded-xl rounded-tr-[4px] p-3 max-w-[80%] text-left">
          {children}
        </div>
        {
          !isNotModify &&
          <button className="text-[#878A92] underline text-[13px] mt-1"
            onClick={() => clickModify(true)}
          >
            수정
          </button>
        }
      </div>
    );
}

export default MessageUser;